export default "__VITE_ASSET__C_8dRxGj__"